import React, { Component } from 'react';
import '../../../../styles/variables.css';
import './AddVacancies.css';
import {connect} from 'react-redux';
import {manageVacancy} from '../../../../actions/_admin_actions';
import database from '../../../../firebase/firebase';
import {ShowNotification} from '../../../../components/HandleNotifications';
import {NotificationContainer} from 'react-notifications';
import Moment from 'moment';
import CurrencyFormat from 'react-currency-format';
import JobDetailModal from '../components/JobDetailModal';

class AddVacancies extends Component {

    state = {
        totalVacancies: 0,
        vacancies: [],
        renderModal: false,
        showModal: false,
        currentJob: {}
    }

    componentDidMount(){
        this.getVacancies()
    }

    getVacancies = () => {
        this.setState({
            vacancies:[]
        })
        this.props.vacancies.map((job) => {
            if(job.Status && job.Permission === "waiting"){
                this.setState(prevState => ({
                    vacancies: [...prevState.vacancies, job]
                }))
            }
        })
    }

    manageVacancy = (data, action) => {
        Moment.locale('es');
        var date =  Moment(new Date()).format('MMM D YYYY,');
        let permission = action ? "accept" : "deny";
        let message = action ? "acepto" : "rechazo";
        const newValues = this.props.vacancies.filter((job) => data.jobID === job.jobID)
        newValues[0].Permission = permission;
        newValues[0].applicantsCount = 0;
        newValues[0].postedFrom = date;
        database
            .collection(`companies`).doc(`${data.vacancyOwner}/jobs/${data.jobID}`)
            .update({Permission: permission, postedFrom: date, applicantsCount: 0})
            .then(()=>{
                return database.collection('vacancies').doc(data.jobID)
                .update({Permission: permission, postedFrom: date, applicantsCount: 0});
            })
            .then(() => {
                ShowNotification('success',`Se ${message} la vacante de manera correcta` ,'Todo listo');
                this.props.updateJobs(this.props.vacancies);
                this.getVacancies()
            });
    }

    truncateString = (str, num) => {
        if (str.length <= num) {
          return str
        }
        return str.slice(0, num) + '...'
      }

    strip_html_tags = (str) => {
        if ((str===null) || (str===''))
            return false;
        else
            str = str.toString();
        return str.replace(/<[^>]*>/g, '');
    }

    showMore = (data)=>{
        this.setState({
            currentJob: data,
            showModal: true,
            renderModal: true
        })
    }
    ToggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            renderModal: !prevState.renderModal
        }));
    }

    render(){
        return(
            <div className="container">
                <div className='a-main-card'>
                    <div className="adt">
                        <p className="-title">Aceptar Solicitudes de Vacantes</p>
                    </div>
                    {this.state.vacancies.map((job) => {
                        return <div key={job.jobID} className="a-inline-dash-card">
                            <div className="-content">
                                <img className="-profile" alt="apc" src={job.img}/>
                                <div className="-info">
                                    <p className="d-job-title">{job.jobTitle}</p>
                                    <p className="d-companyName">{job.companyName}</p>
                                    <p className="d-hireName">{job.contratc}</p>
                                    <p className="d-see-more" onClick={() => { this.showMore(job) }}>Ver más</p>
                                </div>
                                <div className="-desc">
                                    <p className="d-job-title">Descripción: </p>
                                    <p className="d-companyName">{ this.truncateString(this.strip_html_tags(job.data), 125)  }</p> 
                                </div>
                                <div className="-amount">
                                    <p className="d-job-title">Oferta: </p>
                                    <CurrencyFormat className="d-job-title" value={job.jobSalary} 
                                    displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                </div>
                            </div>
                            <div className="-a-links">
                                <button className="-b-acceptd" onClick={() => this.manageVacancy(job, false)}>Declinar</button>
                                <button className="-b-accept" onClick={() => this.manageVacancy(job, true)}>Aceptar</button>
                            </div>
                        </div>
                    })}
                    {this.state.vacancies.length === 0 ? 
                    <p className="text-no">De momento no hay ninguna solicitud de vacante.</p> : null}
                </div>
                {this.state.renderModal ? <JobDetailModal data={this.state.currentJob} 
                open={this.state.showModal} close={this.ToggleModal}/> : null}
                <NotificationContainer />
            </div>
        )
    }
}


const mapDispatchToProps = (dispatch) => ({
    updateJobs: (newVals) => dispatch(manageVacancy(newVals))
});
const mapStateToProps = (state) => ({
    vacancies: state.admin
});

export default connect(mapStateToProps, mapDispatchToProps)(AddVacancies);